<ng-container *ngIf="show">
    <!-- <mat-progress-bar
        [mode]="mode"
        [value]="progress"></mat-progress-bar> -->
    <app-loading-block></app-loading-block>
</ng-container>
